import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import ReactTable from "../../AppComponent/Table";
import _, { values } from "lodash";
import {
    resetSkillAssessmentEmpData,
    stateresetDesignationData,
    stateresetZoneData,
    stateresetRegionData,
    stateresetStateData,
    stateresetBranchData,
    settheempsillassessmentsids,
    SetTheIDs,
    setTheSillAsssessmentsAppsideCompleted
} from "../../../Redux/Slice"
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import { useNavigate } from "react-router-dom";


const Skillassessmentemp = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const dispatch = useDispatch();
    const state = useSelector((state) => state);
    const [sno, setsno] = useState(0);
    const [dtpageindex, setdtPageindex] = useState(1);
    const [yearAndMonth, setYearMpnth] = useState();
    const [search, setsearch] = useState("");
    const [stateoptions, setoptions] = useState()

    const [regionOptions, setRegionOptions] = useState([]);
    const [zoneOptions, setZoneOptions] = useState([]);
    const [designationOptions, setDesignationOptions] = useState([]);
    const [clientOptions, setClientOptions] = useState([]);
    const initialState = {
        state: "",
        region: "",
        zone: "",
        client_id: "",
        role_id: "",
    }
    const [datas, setdatas] = useState(initialState)

  
    
    const [completedstatus, setcompletedstus] = useState({
        completed:
            false,
    });
    const [AllEmp, setALlEMp] = useState(
        {
            label: "Pending",
            value: false,
        },
    );
    const optionsforfilter = [
        {
            label: "Pending",
            value: false,
        },
        {
            label: "Completed",
            value: true,
        },

    ];


    // const [selectVal, SetSelectval] = useState(FileterState);
    const navigate = useNavigate();
    const date = new Date();
    const months =
        date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;


    useEffect(() => {
        const payload = {
            search: search,
            page_size: 10,
            page: dtpageindex,
            month: "",
            year: "",
            // status: selectVal.status,
            zone: datas.zone,
            state: datas.state,
            region: datas.region,
            is_completed: completedstatus.completed,
            client_id: datas.client_id,
            role: datas.region,
        }
        dispatch(resetSkillAssessmentEmpData(payload))
    }, [dtpageindex, datas, search,  completedstatus.completed])
    useEffect(() => {
        dispatch(stateresetStateData())
    }, [])


    // -----Search------------------------
    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    // const ClearState = (counts) => {
    //     setOptionvalues({ value: "", label: "All" })
    //     SetSelectval({
    //         ...selectVal,
    //         status: "",

    //     });
    // };

    // const count = (Counts, values, sel, SelectedValues) => {
    //     setOptionvalues(SelectedValues)
    //     SetSelectval({
    //         ...selectVal,
    //         status: SelectedValues.value
    //     });
    // };

    useEffect(() => {
        if (datas.state != "") {
            const payload = {
                state: datas.state
            }
            dispatch(stateresetRegionData(payload))
        }
    }, [datas.state])
    useEffect(() => {
        if (datas.region != "" && datas.state != "") {
            const payloads = {
                state: datas.state,
                region: datas.region,
            };
            dispatch(stateresetZoneData(payloads));
        }
    }, [datas.region, datas.state]);


    useEffect(() => {
        const payloads = {
            state: datas.state,
            region: datas.region,
            zone: datas.zone
        };
        dispatch(stateresetBranchData(payloads));

    }, [datas.region, datas.state, datas.zone]);
    useEffect(() => {
        if (state.BranchFetchDetails.branchData != undefined) {
            let objectArray = [];
            state.BranchFetchDetails.branchData.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });

            setClientOptions(objectArray);
        }
    }, [state.BranchFetchDetails.branchData,]);

    useEffect(() => {
        if (datas.client_id != "") {
            const payload = {
                client: datas.client_id
            }
            dispatch(stateresetDesignationData(payload));
        }
    }, [datas.client_id])

    useEffect(() => {
        if (state.StateFetchDetails.stateData != undefined) {
            let objectArray = [];
            state.StateFetchDetails.stateData.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.state_name.toUpperCase(),
                });
            });

            setoptions(objectArray);
        }
    }, [state.StateFetchDetails.stateData,]);

    useEffect(() => {
        if (state.ZoneFetchDetails.zoneData != undefined) {
            let objectArray = [];
            state.ZoneFetchDetails.zoneData.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.zone_name.toUpperCase(),
                });
            });

            setZoneOptions(objectArray);
        }
    }, [state.ZoneFetchDetails.zoneData,]);


    useEffect(() => {
        if (state.RegionFetchDetails.regionData != undefined) {
            let objectArray = [];
            state.RegionFetchDetails.regionData.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.region_name.toUpperCase(),
                });
            });

            setRegionOptions(objectArray);
        }
    }, [state.RegionFetchDetails.regionData,]);

    useEffect(() => {
        if (state.DesignationFetchDetails.designationData != undefined) {
            let objectArray = [];
            state.DesignationFetchDetails.designationData.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.role.toUpperCase(),
                });
            });

            setDesignationOptions(objectArray);
        }
    }, [state.DesignationFetchDetails.designationData, datas.client_id]);


    const handleSelectChange = (field, selectedOption) => {
        console.log(field, "pOSI field");
        if (field == "client_id") {
            setdatas((prevData) => ({
                ...prevData,
                [field]: selectedOption ? selectedOption.value : "",
                role_id: ""
            }));

        }
        if (field == "zone") {
            setdatas((prevData) => ({
                ...prevData,
                [field]: selectedOption ? selectedOption.value : "",
                zone: ""
            }));

        }

        if (field == "state") {
            setdatas((prevData) => ({
                ...prevData,
                [field]: selectedOption ? selectedOption.value : "",
                region: "",
                zone: "",
                client_id: "",
                role_id: ""
            }));

        }

        setdatas((prevData) => ({
            ...prevData,
            [field]: selectedOption ? selectedOption.value : "",
        }));
    };

    const findOptionByValue = (options = [], value) => options.find(option => option.value === value) || null;




    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };
    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);
        }
    };
    const pagesize = (arg) => {
    };

    const pageindex = (arg) => {
        setdtPageindex(arg);
    };
    const columns = useMemo(
        () => [
            {
                Header: "EMPLOYEE NAME",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.user_id.first_name != undefined ? (
                                <span>{row.row.original.user_id.first_name}</span>
                            ) : (
                                <span>{"--"}</span>
                            )}
                        </>
                    );
                },
            },

            {
                Header: "DESIGNATION",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.user_id.user_role != undefined &&
                                row.row.original.user_id.user_role.role != undefined ? (
                                <span>{row.row.original.user_id.user_role.role}</span>
                            ) : (
                                <span>{"--"}</span>
                            )}
                        </>
                    );
                },
            },


            {
                Header: "CREATE DATE",
                accessor: "",
                Cell: (row) => {
                    const dateString = row.row.original.user_id.created_at;
                    const dateObject = new Date(dateString);
                    const hours = dateObject.getHours();
                    const minutes = dateObject.getMinutes();
                    const seconds = dateObject.getSeconds();
                    const amOrPm = hours >= 12 ? "PM" : "AM";
                    const twelveHourFormat = hours % 12 || 12;
                    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                    const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                    return (
                        <>
                            <span>
                                {row.row.original.user_id.created_at != undefined &&
                                    row.row.original.user_id.created_at != null
                                    ? `${row.row.original.user_id.created_at.slice(0, 10) +
                                    "  " +
                                    formattedTime
                                    }`
                                    : "---"}
                            </span>
                        </>
                    );
                },
            },


            {
                Header: "GRADE",
                accessor: "",
                Cell: (row) => {
                    return (
                        <>
                            {row.row.original.is_completed != undefined &&
                                row.row.original.is_completed != null ? (
                                <span>{row.row.original.is_completed == true ?
                                    <><span className="statusstyles">{row.row.original.grade}</span></>:
                                    <>{"----"}</>
                                }</span>
                            ) : (
                                <span>{"--"}</span>
                            )}
                        </>
                    );
                },
            },


            {
                Header: "STATUS",
                accessor: "",
                Cell: (row) => {
                    if (
                        row.row.original.perform_answer != null &&
                        row.row.original.perform_answer.status != undefined &&
                        row.row.original.perform_answer.status != null
                    ) {
                        const originalString =
                            row.row.original.perform_answer != undefined &&
                                row.row.original.perform_answer != null
                                ? row.row.original.perform_answer.status
                                : "";
                        const capitalizedString = capitalizeFirstLetter(originalString);
                        return (
                            <>
                                {row.row.original.perform_answer != undefined &&
                                    row.row.original.perform_answer.status != undefined ? (
                                    <>
                                        {row.row.original.perform_answer.status.toLowerCase() ==
                                            "pending" ? (
                                            <div className="StatusList">
                                                <img src={Pendingimg} />
                                                <span>{capitalizedString}</span>
                                            </div>
                                        ) : (
                                            <>
                                                {row.row.original.perform_answer.status.toLowerCase() ==
                                                    "decline" ? (
                                                    <div className="StatusList">
                                                        <div className="DeclineStatus">
                                                            <span>x</span>
                                                        </div>
                                                        <span>{capitalizedString}</span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {row.row.original.perform_answer.status.toLowerCase() ==
                                                            "approved" ? (
                                                            <div className="StatusList">
                                                                <img src={correctIcons} />
                                                                <span>{capitalizedString}</span>
                                                            </div>
                                                        ) : null}
                                                    </>
                                                )}
                                            </>
                                        )}
                                    </>
                                ) : (
                                    <span>---</span>
                                )}
                            </>
                        );
                    } else if (row.row.original.perform_answer == null) {
                        return (
                            <>
                                <p>{"-----"}</p>
                            </>
                        );
                    }
                },
            },

            // {
            //     Header: "ACTIONS",
            //     accessor: "",
            //     Cell: (row) => {
            //         return (
            //             <>
            //                 <div
            //                     class="actions"
            //                     style={{
            //                         display: "flex",
            //                         justifyContent: "flex-start",
            //                         gap: "5px",
            //                     }}
            //                 >
            //                     <button
            //                         className=" btn Status"
            //                         onClick={(e) => {
            //                             dispatch(settheempsillassessmentsids(row.row.original.user_id.id));
            //                             navigate("/assements_apply");
            //                         }}
            //                         component="span"
            //                     >
            //                         <span className="OuterActionSpan">

            //                             <span className="EditImages">
            //                                 <img src={EditImages} />
            //                             </span>
            //                             <span className="ActionsList"> Edit </span>
            //                         </span>
            //                     </button>
            //                 </div>
            //             </>
            //         );
            //     },
            // },

        ].filter(Boolean), [sno]
    );

    const handlechangescompletd = (e) => {
        setdtPageindex(1);
        setALlEMp(e);
        setcompletedstus({
            completed: e.value,
        });
        // dispatch(setTheSillAsssessmentsAppsideCompleted(e));
    };


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div className="leaveWrapper">

                    <div className="row ButtonPrevious Filters"
                        style={{
                            margin: "0px",
                            position: "relative",
                            zIndex: "30",
                            marginLeft: "0px",
                            marginRight: "0px",
                        }}>
                        <div className="col-12 leaveHeading text-left">
                            <h3>SKILL ASSESSMENT</h3>
                        </div>


                    </div>
                    <div
                        className="row Filters"
                        style={{
                            padding: "15px 0px",
                            margin: "0px",
                            position: "relative",
                            zIndex: "30",
                            marginLeft: "0px",
                            marginRight: "0px",
                            top: "-10px",
                        }}
                    >
                        <div className="col-sm-2">
                            <label for="validationCustom01" class="form-label">
                                State
                            </label>
                            <Select
                                className="Selects"
                                options={stateoptions}
                                onChange={(selectedOption) => handleSelectChange("state", selectedOption)}
                                value={findOptionByValue(stateoptions, datas.state)}

                                styles={{ position: "relative", top: "60px" }} />
                        </div>
                        <div className="col-sm-2">
                            <label for="validationCustom01" class="form-label">
                                Region
                            </label>
                            <Select
                                className="Selects" options={regionOptions}
                                onChange={(selectedOption) => handleSelectChange("region", selectedOption)}
                                value={findOptionByValue(regionOptions, datas.region)}

                                styles={{ position: "relative", top: "60px" }} />
                        </div>
                        <div className="col-sm-2">
                            <label for="validationCustom01" class="form-label">
                                Zone
                            </label>
                            <Select
                                className="Selects" options={zoneOptions}
                                onChange={(selectedOption) => handleSelectChange("zone", selectedOption)}
                                value={findOptionByValue(zoneOptions, datas.zone)}

                                styles={{ position: "relative", top: "60px" }} />
                        </div>
                        <div className="col-sm-2">
                            <label for="validationCustom01" class="form-label">
                                Branch List
                            </label>
                            <Select
                                className="Selects"
                                options={clientOptions}
                                onChange={(selectedOption) => handleSelectChange("client_id", selectedOption)}
                                value={findOptionByValue(clientOptions, datas.client_id)}

                                styles={{ position: "relative", top: "60px" }} />
                        </div>

                        <div className="col-sm-2">
                            <label
                                for="validationCustom01"
                                class="form-label">
                                Designation
                            </label>
                            <Select
                                className="Selects" options={designationOptions}
                                onChange={(selectedOption) => handleSelectChange("role_id", selectedOption)}
                                value={findOptionByValue(designationOptions, datas.role_id)}

                                styles={{ position: "relative", top: "60px" }} />
                        </div>
                    </div>

                    <div className="col-12 leaveSubHeading">
                        <ReactTable
                            data={state.SkillAssessmentEmpList.skillAssessmentDataEMpdata}
                            datacount={state.SkillAssessmentEmpList.Total_Count}
                            columns={columns}
                            pagesize={pagesize}
                            dtpagesize={20}
                            dtpageindex={dtpageindex}
                            pageindex={pageindex}
                            Search={false}
                            onPrevious={handlePrevious}
                            onNextpage={handleNext}
                            GotoEnteredPage={GotoEnteredPage}
                            Filter={true}
                            // values={OptionValues}
                            // options={options}
                            // count={count}
                            // ClearState={ClearState}
                            onChange={tochange}
                            setsno={setsno}
                            sno={sno}
                            id={"spe"}
                            MakeCreate={true}
                            iscompletedLabel="Status"

                            nostatusFilter={true}
                            ///--APp side completed ViewFileterState
                            AppSideView={true}
                            AllEmp={AllEmp}
                            handlechangescompletd={handlechangescompletd}
                            optionsforfilter={optionsforfilter}

                            ViewParts={(e) => {
                                dispatch(settheempsillassessmentsids(e.user_id.id));
                                dispatch(SetTheIDs(e.user_id.id));

                                navigate("/assessments_apply");
                            }}
                        />
                    </div>

                </div>
            </div>
        </>
    )
}

export default Skillassessmentemp